import { gql } from '@apollo/client/core/index.js'

/**
 * NOTE: this query operation is referenced in e2e test fixtures
 * in order to intercept this query and mock out a response for test impersonation
 */
export const queries = {
  /** @deprecated - Remove this gary call from flight-deck. Use select principal instead */
  MAIN_SESSION: gql`
  query SELECT_MainSession {
    session {
      id
      active
      user_id
      first_name
      last_name
      email_addr
      admin
      user_role
      role {
        id
        name
        scope
        assignable_to
        __typename
      }
      advertisers {
        advertiser_id
        company_name
      }
      current_advertiser {
        advertiser_id
        company_name
        logo
        __typename
      }
      two_factor_auth {
        sms_enabled
        sms_device_verified_at
        sms_recovery_phone_number
        ga_enabled
        ga_device_verified_at
        required
        __typename
      }
      permissions {
        hotelPermissions
        advertiserPermissions
        systemPermissions
        unlimitedPower
        __typename
      }
      __typename
    }
  }
`,
  PTV_SESSION: gql`
    query SELECT_PtvSession{
      session {
        id
        user_id
        first_name
        last_name
        email_addr
        advertisers {
          advertiser_id
          company_name
          logo
        }
        current_advertiser {
          advertiser_id
          company_name
          logo
        }
        __typename
      }
    }
  `,
  PTV_SESSION_COOKIE: gql`
    query SELECT_PtvSessionCookie{
      session {
        id
        __typename
      }
    }
  `,
  // https://github.com/SteelHouse/gary-ql/blob/master/src/gql/types/User/schema.graphql
  GET_USER_BY_ID: gql`
    query SELECT_GetUserById($userId: Int!) {
      getUserById(user_id: $userId) {
        id
        email_addr
        role {
          name
        }
        current_advertiser {
          id
          advertiser_id
          company_name
          logo
          company_url
          last_login_time_for_user
        }
        advertisers {
          advertiser_id
          company_name
          logo
          company_url
          last_login_time_for_user
        }
      }
    }
  `,
}

export const mutations = {
  LOGOUT: gql`
    mutation Logout {
      logout {
        user_id
      }
    }
  `,

  SWITCH_ADVERTISER: gql`
    mutation SELECT_SwitchAdvertiser($advertiserId: Int!) {
      switchAdvertiser(advertiser_id: $advertiserId) {
        user_id
      }
    }
  `,
}
